import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { StorekeeperIssuePayload } from '../models/clothing.model';

@Component({
  selector: 'app-clothing-issue-modal',
  templateUrl: './clothing-issue-modal.component.html',
  styleUrls: ['./clothing-issue-modal.component.css']
})
export class ClothingIssueModalComponent {
  public itemName = '';
  public issuedQuantity = 1;
  public maxQuantity = 1;
  public issueDate = '';
  public maxDate = this.createTodayDate();

  constructor(public activeModal: NgbActiveModal) {
    this.issueDate = this.maxDate;
  }

  setValues(itemName: string, issuedQuantity: number): void {
    this.itemName = itemName;
    this.maxQuantity = this.resolveQuantity(issuedQuantity);
    this.issuedQuantity = this.maxQuantity;
  }

  confirm(): void {
    if (!this.isQuantityValid()) {
      return;
    }
    this.activeModal.close(this.createPayload());
  }

  cancel(): void {
    this.activeModal.dismiss();
  }

  isQuantityValid(): boolean {
    if (this.issuedQuantity < 1) {
      return false;
    }
    return this.issuedQuantity <= this.maxQuantity;
  }

  private createPayload(): StorekeeperIssuePayload {
    return {
      issuedQuantity: this.issuedQuantity,
      issueDate: this.resolveIssueDate()
    };
  }

  private resolveQuantity(issuedQuantity: number): number {
    if (issuedQuantity && issuedQuantity > 0) {
      return issuedQuantity;
    }
    return 1;
  }

  private resolveIssueDate(): string {
    if (this.issueDate && this.issueDate.length) {
      return this.issueDate;
    }
    return '';
  }

  private createTodayDate(): string {
    return new Date().toISOString().slice(0, 10);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/modals/clothing-issue-modal.component.ts